import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-sign-inmodal',
  imports: [RouterModule, MatIconModule, FormsModule, ReactiveFormsModule],
  templateUrl: './sign-in-modal.component.html',
  styleUrl: './sign-in-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInModalComponent implements OnInit {
  dialogRef = inject(DialogRef);
  datax = inject(DIALOG_DATA);
  signInForm: UntypedFormGroup;

  loadingSignInEmail = false;
  loadingSignInGoogle = false;
  loadingSignInApple = false;
  errorMessage: string | null = null;

  ngOnInit() {
    // add signIn and logout items if user is authenticated
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  constructor(
    private _authService: AuthService,
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) {
    this.signInForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  onSignIn(): void {
    if (this.signInForm.invalid) {
      return;
    }

    this.loadingSignInEmail = true;
    this.errorMessage = null;
    this._cdr.markForCheck();

    const { email, password } = this.signInForm.value;
    this._authService
      .signInWithEmail(email, password)
      .then(() => {
        this.dialogRef.close();
        window.location.reload();
      })
      .catch((err) => (this.errorMessage = err.message))
      .finally(() => {
        this.loadingSignInEmail = false;
        this._cdr.markForCheck();
      });
    // Handle sign-in logic here
  }

  onForgotPassword(): void {
    // Handle forgot password logic here
  }
  onSignUp(): void {
    // Handle sign-up logic here
  }
  onSignInWithGoogle(): void {
    this.loadingSignInGoogle = true;
    this.errorMessage = null;
    this._cdr.markForCheck();

    // Handle sign-in with Google logic here
    this._authService
      .loginWithGoogle()
      .then(() => {
        this.dialogRef.close();

        window.location.reload();
      })
      .catch((err) => {
        this.errorMessage = err.message;
      })
      .finally(() => {
        this.loadingSignInGoogle = false;
        this._cdr.markForCheck();
      });
  }

  onSignInWithApple(): void {
    this.loadingSignInApple = true;
    this.errorMessage = null;
    this._cdr.markForCheck();
    // Handle sign-in with Apple logic here
    this._authService
      .loginWithApple()
      .then(() => {
        this.dialogRef.close();
        window.location.reload();
      })

      .catch((err) => {
        this.errorMessage = err.message;
      })
      .finally(() => {
        this.loadingSignInApple = false;
        this._cdr.markForCheck();
      });
  }
}
